export default class FavoriteShowService {
	constructor(apiService) {
		this.apiService = apiService
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/favoriteShows/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/FavoriteShowService.js